import { Event } from "../../../base/common/events.js";
import { Disposable } from "../../../base/common/lifecycle.js";
import { ILogService } from "../../log/common/log.js";
import { IWebGLEngine, IWebGLService, WebGLServiceChangedEvent } from "./webgl.js";



export class WebGLService extends Disposable implements IWebGLService {

    private engines: Map<string, IWebGLEngine> = new Map();

    constructor(
        @ILogService private readonly logger: ILogService,
    ) {
        super();
    }

    onDidChange: Event<WebGLServiceChangedEvent>;

    getAllEngines(): IWebGLEngine[] {
        return Array.from(this.engines.values());
    }
    getEngine<T extends IWebGLEngine>(name: string): T | undefined {
        return this.engines.get(name) as T | undefined;
    }
    registerEngine(engine: IWebGLEngine): void {
        if (this.engines.has(engine.name)) {
            this.logger.warn(`WebGLService: Engine with name '${engine.name}' is already registered.`);
            return;
        }
        this.engines.set(engine.name, engine);
    }
    hasEngine(name: string): boolean {
        return this.engines.has(name);
    }
}